import React from "react";
import PlatformLayout from "../../components/platform/PlatformLayout";
import { PlatformZones } from "../../components/platform/PlatformZones";

const HowItWorks: React.FC = () => {

 return (
  <PlatformLayout>
   {/* Dynamically render zones based on stored order */}
   <PlatformZones pageSlug="how-it-works" />
  </PlatformLayout>
 );
};

export default HowItWorks;

